/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StudentMetaAvailableCAT2122Data model module.
 * @module model/StudentMetaAvailableCAT2122Data
 * @version 1.0.0
 */
class StudentMetaAvailableCAT2122Data {
    /**
     * Constructs a new <code>StudentMetaAvailableCAT2122Data</code>.
     * @alias module:model/StudentMetaAvailableCAT2122Data
     */
    constructor() { 
        
        StudentMetaAvailableCAT2122Data.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentMetaAvailableCAT2122Data</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentMetaAvailableCAT2122Data} obj Optional instance to populate.
     * @return {module:model/StudentMetaAvailableCAT2122Data} The populated <code>StudentMetaAvailableCAT2122Data</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentMetaAvailableCAT2122Data();

            if (data.hasOwnProperty('tienda')) {
                obj['tienda'] = ApiClient.convertToType(data['tienda'], 'String');
            }
            if (data.hasOwnProperty('id_ciclo')) {
                obj['id_ciclo'] = ApiClient.convertToType(data['id_ciclo'], 'Number');
            }
            if (data.hasOwnProperty('formative_zone_code')) {
                obj['formative_zone_code'] = ApiClient.convertToType(data['formative_zone_code'], 'String');
            }
            if (data.hasOwnProperty('official_code')) {
                obj['official_code'] = ApiClient.convertToType(data['official_code'], 'String');
            }
            if (data.hasOwnProperty('ciclo')) {
                obj['ciclo'] = ApiClient.convertToType(data['ciclo'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} tienda
 */
StudentMetaAvailableCAT2122Data.prototype['tienda'] = undefined;

/**
 * @member {Number} id_ciclo
 */
StudentMetaAvailableCAT2122Data.prototype['id_ciclo'] = undefined;

/**
 * @member {String} formative_zone_code
 */
StudentMetaAvailableCAT2122Data.prototype['formative_zone_code'] = undefined;

/**
 * @member {String} official_code
 */
StudentMetaAvailableCAT2122Data.prototype['official_code'] = undefined;

/**
 * @member {String} ciclo
 */
StudentMetaAvailableCAT2122Data.prototype['ciclo'] = undefined;






export default StudentMetaAvailableCAT2122Data;

